import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import NeuralCanvas from '../components/NeuralCanvas';
import WordmarkLogo from '../components/WordmarkLogo';
import '../global.css';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--bg)',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      padding: '40px 24px', textAlign: 'center',
      position: 'relative', overflow: 'hidden',
    }}>
      <NeuralCanvas />

      <div style={{ position: 'relative', zIndex: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0 }}>
        <div style={{ marginBottom: 48 }}>
          <WordmarkLogo size={20} linkTo="/" />
        </div>

        <div style={{
          fontFamily: 'var(--font-mono)', fontSize: 10,
          letterSpacing: '0.2em', color: 'var(--accent)',
          textTransform: 'uppercase', marginBottom: 28,
          padding: '4px 14px', border: '1px solid rgba(139,124,255,0.2)',
          borderRadius: 999, background: 'rgba(139,124,255,0.05)',
        }}>
          404
        </div>

        <h1 style={{
          fontSize: 'clamp(26px, 5vw, 38px)', fontWeight: 400,
          letterSpacing: '-0.03em', color: 'var(--fg)',
          marginBottom: 14, lineHeight: 1.1,
        }}>
          Page not found.
        </h1>

        <p style={{
          fontSize: 14, color: 'var(--fg-dim)', lineHeight: 1.7,
          maxWidth: '34ch', marginBottom: 40,
        }}>
          The page you're looking for doesn't exist or has moved.
        </p>

        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', justifyContent: 'center' }}>
          <button onClick={() => navigate(-1)} className="btn btn-ghost" style={{ padding: '9px 20px', fontSize: 13 }}>
            ← Back
          </button>
          <Link to="/" className="btn btn-primary" style={{ padding: '9px 20px', fontSize: 13 }}>
            Home
          </Link>
        </div>
      </div>

      <div style={{
        position: 'absolute', bottom: 28, zIndex: 2,
        fontFamily: 'var(--font-mono)', fontSize: 10,
        color: 'var(--fg-faint)', letterSpacing: '0.12em',
      }}>
        CYBERNATE · CYB-1
      </div>
    </div>
  );
}
